export default class LoadingLine {
  constructor(canvas) {
    this.canvas = canvas
    this.parent = this.canvas.parentElement
    this.ctx = this.canvas.getContext('2d')

    this.docs = {
      width: 0,
      height: 0,
    }

    this.weight = {
      pc: 14 / 2,
      sp: 7 / 2,
    }

    this.peaks = {
      pc: [
        { x: -10, y: 586 },
        { x: 763, y: -153 },
        { x: 1140, y: 193 },
        { x: 1930, y: -595 },
      ],
      sp: [
        { x: -10, y: 122 },
        { x: 154, y: -35 },
        { x: 232, y: 36 },
        { x: 400, y: -131 },
      ],
    }

    this.isPC = true

    // ウィンドウのリサイズ
    window.addEventListener('resize', this.resize)
    this.resize()

    // アニメーション開始
    this.draw()
  }

  resize() {
    const { canvas, parent } = this

    this.docs.width = parent.clientWidth
    this.docs.height = parent.clientHeight
    canvas.width = this.docs.width
    canvas.height = this.docs.height

    this.isPC = document.documentElement.clientWidth > 768
  }

  draw = (progress) => {
    const { ctx, docs, isPC } = this
    const { width, height } = docs

    const peaks = isPC ? this.peaks.pc : this.peaks.sp
    const weight = isPC ? this.weight.pc : this.weight.sp

    // アニメーション完了状態なら描画をストップする
    if (this.isFinished) return

    // Canvasをクリア（透明にする）
    ctx.clearRect(0, 0, width, height)

    ctx.beginPath()

    // 塗りつぶしのスタイル設定
    ctx.fillStyle = 'white'
    // 線の結合部分をマイター（鋭角）にしてエッジを保つ
    ctx.lineJoin = 'miter'
    // 線が極端に太くなっても面取り(bevel)されないように上限を大きく設定
    ctx.miterLimit = 10000
    ctx.lineCap = 'butt'
    // ぼかしの設定
    ctx.shadowColor = 'rgba(255, 255, 255, 1)' // ぼかしの色
    ctx.shadowBlur = 10 // ぼかしの量（ピクセル）

    // 線を描画
    for (let repeat = 0; repeat < 3; repeat++) {
      for (let loop = 0; loop < 2; loop++) {
        const length = peaks.length
        for (let i = 0; i < length; i++) {
          const id = loop == 0 ? i : length - 1 - i
          const dir = loop == 0 ? -1 : 1

          const step = document.documentElement.clientHeight * progress * dir

          const peak = peaks[id]
          const x = this._rem(peak.x)
          const y = height * 0.5 + this._rem(peak.y) + this._rem(weight * dir) + step

          if (loop == 0 && id == 0) {
            ctx.moveTo(x, y)
          } else {
            ctx.lineTo(x, y)
          }
        }
      }
      ctx.closePath()
      ctx.fill()
    }
  }

  _rem(px) {
    const base = this.isPC ? 1920 : 390
    return (px / base) * document.documentElement.clientWidth
  }
}
